import React, {lazy, Suspense} from 'react'

const DevotionDetailLazy = lazy(() =>
    import('./DevotionDetail')
)

const Fallback = () => (
    <div className="min-h-screen flex items-center justify-center">
        <p className="text-gray-400 text-sm">Đang tải...</p>
    </div>
)

const DevotionDetail = props => (
    <Suspense  fallback={<Fallback/>}>
        <DevotionDetailLazy {...props} />
    </Suspense>
)

export default DevotionDetail
